import React from "react";
import Header from "../../headerone/Main";
import Bredcom from "../../Bredcom/Main";
import BlogThree from "../../Blogdetails/BlogThree";

function Main() {
  return (
    <>
      <section className="hide-overflow">
        <Header />
        <Bredcom
          title="Home"
          subtitle="A Day in the Life of a Pharmacy Student: What to Expect"
        />
        <BlogThree />
      </section>
    </>
  );
}

export default Main;
